import { Package } from '@workspaces/types'
import { formatDateISO } from '@/filters/dateFormat'

export function serializePlanPackage(content: Package.PlanPackage): string {
  const dateRange = content.filter?.dateRange
  if (Array.isArray(dateRange) && dateRange.length === 2) {
    // Campaign dates are calendar dates, not instants: store them as
    // timezone-less 'YYYY-MM-DD' strings so every viewer sees the same day.
    const serializable = {
      ...content,
      filter: {
        ...content.filter,
        dateRange: dateRange.map((date) =>
          date instanceof Date ? formatDateISO(date) : date,
        ),
      },
    }
    return JSON.stringify(serializable)
  }
  return JSON.stringify(content)
}
